'use client';

// Seção "Muito mais que um simples tracking" · entre Instalação e Integrações.
// Carrossel cinematográfico: card animado (tilt 3D no cursor) à esquerda + texto
// que troca em sincronia à direita. Indicador "expanding dot" com auto-advance.
// Portado fiel do mockup aprovado no companion.

import { useEffect, useRef, useState, type ReactNode } from 'react';
import { RiClaudeFill } from 'react-icons/ri';
import {
  TbBolt,
  TbBrandMeta,
  TbMail,
  TbPlayerPause,
  TbReceiptRefund,
  TbShoppingCartX,
  TbTrendingDown,
  TbTrendingUp,
  TbUsersGroup,
} from 'react-icons/tb';

import styles from './funcionalidades.module.css';

const DUR = 10000;
const BX = 6;
const BY = -11;

type Slide = { pre: string; g: string; suf: string; body: ReactNode };

const SLIDES: Slide[] = [
  {
    pre: 'Acorde sabendo quanto você ',
    g: 'lucrou ontem',
    suf: '',
    body: (
      <>
        Enquanto você dormia, o Trakd fechou a conta do dia: <b>faturamento, ROAS real, CPA</b> e
        quais criativos puxaram (ou queimaram) o seu dinheiro. Você abre o e-mail e já sabe{' '}
        <b>o que escalar e o que cortar</b>, sem garimpar Gerenciador nem montar planilha.
      </>
    ),
  },
  {
    pre: 'Converse com seus dados direto no ',
    g: 'Claude Code',
    suf: '',
    body: (
      <>
        A conexão é simples e leva segundos. Feito isso, o Claude Code enxerga tudo que a Trakd
        guarda dos seus eventos da Meta: <b>agende relatórios</b>,{' '}
        <b>monte apresentações de resultado</b> ou investigue qualquer campanha, sem abrir um
        painel.
      </>
    ),
  },
  {
    pre: 'Os públicos que mais convertem, ',
    g: 'no automático',
    suf: '',
    body: (
      <>
        A Trakd cria e mantém atualizados, direto no seu Gerenciador, três públicos que valem ouro:
        os <b>reembolsados</b>, o <b>lookalike dos reembolsados</b> (pra excluir quem só dá dor de
        cabeça) e o de <b>carrinho abandonado</b>. E quando quiser, você exporta tudo em{' '}
        <b>CSV ou XLS</b> num clique.
      </>
    ),
  },
  {
    pre: 'Suas campanhas no ',
    g: 'piloto automático',
    suf: ', dia e noite',
    body: (
      <>
        Defina a regra uma vez e pronto: CPA estourou, a Trakd <b>pausa</b>. ROAS voando, ela{' '}
        <b>escala</b>. Suas campanhas ficam vigiadas 24 horas e a ação acontece na hora, sem você
        precisar estar olhando. Você para de queimar verba esperando pra ver o painel de manhã.
      </>
    ),
  },
];

const N = SLIDES.length;

function ReportCard() {
  return (
    <>
      <div className={styles['rhead']}>
        <span
          className={styles['rlogo']}
          role="img"
          aria-label="Trakd"
          style={{
            backgroundImage: 'url(/icons/icon-192.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <div className={styles['ti']}>
          <b>Relatório diário</b>
          <span>terça, 16 jun</span>
        </div>
        <div className={styles['mail']}>
          <TbMail size={12} /> via e-mail
        </div>
      </div>
      <div className={styles['hero']}>
        <div className={styles['heroL']}>Lucro de ontem</div>
        <div className={styles['heroRow']}>
          <div className={styles['heroV']}>R$ 14.382</div>
          <div className={styles['chip']}>+18% vs média</div>
        </div>
      </div>
      <div className={styles['kpis']}>
        <div className={styles['kpi']}>
          <div className={styles['kpiL']}>ROAS</div>
          <div className={`${styles['kpiV']} ${styles['kpiVp']}`}>6,8x</div>
        </div>
        <div className={styles['kpi']}>
          <div className={styles['kpiL']}>CPA</div>
          <div className={styles['kpiV']}>R$ 23,90</div>
        </div>
        <div className={styles['kpi']}>
          <div className={styles['kpiL']}>Vendas</div>
          <div className={styles['kpiV']}>132</div>
        </div>
      </div>
      <div className={styles['chart']}>
        <svg viewBox="0 0 460 64" preserveAspectRatio="none">
          <defs>
            <linearGradient id="fxGf" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stopColor="#5be3a7" stopOpacity=".35" />
              <stop offset="1" stopColor="#5be3a7" stopOpacity="0" />
            </linearGradient>
          </defs>
          <path
            d="M0,50 60,44 120,47 180,30 240,34 300,18 360,24 420,10 460,8 460,64 0,64 Z"
            fill="url(#fxGf)"
          />
          <polyline
            points="0,50 60,44 120,47 180,30 240,34 300,18 360,24 420,10 460,8"
            fill="none"
            stroke="#5be3a7"
            strokeWidth="2.2"
          />
        </svg>
      </div>
      <div className={styles['insights']}>
        <div className={`${styles['ins']} ${styles['insUp']}`}>
          <div className={styles['insIc']}>↑</div>
          <div>
            <small>Escale</small>Criativo &quot;Prova social&quot;
          </div>
        </div>
        <div className={`${styles['ins']} ${styles['insDn']}`}>
          <div className={styles['insIc']}>↓</div>
          <div>
            <small>Corte</small>Conjunto &quot;Frio 02&quot;
          </div>
        </div>
      </div>
    </>
  );
}

function McpCard() {
  return (
    <>
      <div className={styles['link']}>
        <div className={styles['node']}>
          <div
            className={styles['nic']}
            role="img"
            aria-label="Trakd"
            style={{
              backgroundImage: 'url(/icons/icon-192.png)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />
          <b>Trakd</b>
        </div>
        <div className={styles['wire']}>
          <div className={styles['wireLine']} />
          <div className={styles['pkt']} />
          <div className={styles['pkt']} />
          <div className={styles['pkt']} />
          <div className={styles['mcpb']}>
            <i />
            MCP
          </div>
        </div>
        <div className={styles['node']}>
          <div className={`${styles['nic']} ${styles['nicClaude']}`}>
            <RiClaudeFill size={28} color="#D97757" />
          </div>
          <b>Claude Code</b>
        </div>
      </div>
      <div className={styles['term']}>
        <div className={styles['thead']}>
          <span className={styles['theadM']} style={{ background: '#ff5f57' }} />
          <span className={styles['theadM']} style={{ background: '#febc2e' }} />
          <span className={styles['theadM']} style={{ background: '#28c840' }} />
          <span className={styles['theadT']}>claude code</span>
          <span className={styles['theadOn']}>
            <i />
            trakd conectado
          </span>
        </div>
        <div className={styles['tbody']}>
          <div className={styles['q']}>
            <span className={styles['pr']}>&gt;</span> qual criativo tá escalando agora?
          </div>
          <div className={styles['sys']}>
            <span className={styles['sp']} /> consultando sua conta via Trakd
          </div>
          <div className={styles['res']}>
            <div className={styles['resLn']}>
              🏆 <b>Prova social</b> · ROAS <span className={styles['gr']}>9,2x</span> ·{' '}
              <span className={styles['gr']}>R$ 6.480</span>
            </div>
            <div className={styles['resLn']}>
              📈 escalou <span className={styles['vi']}>+34%</span> nas últimas 24h
            </div>
            <div className={styles['ask']}>Quer que eu suba 20% do orçamento dele?</div>
          </div>
        </div>
      </div>
    </>
  );
}

function PublicosCard() {
  return (
    <>
      <div className={styles['phead']}>
        <div className={styles['mglyph']}>
          <TbBrandMeta size={22} />
        </div>
        <div className={styles['ti']}>
          <b>Gerenciador de Anúncios</b>
          <span>Públicos · criados pela Trakd</span>
        </div>
        <div className={styles['sy']}>
          <i />
          sincronizado
        </div>
      </div>
      <div className={styles['auds']}>
        <div className={styles['aud']}>
          <div className={`${styles['aic']} ${styles['aicR']}`}>
            <TbReceiptRefund size={20} />
          </div>
          <div className={styles['ainfo']}>
            <b>Reembolsados</b>
            <span>quem pediu reembolso</span>
          </div>
          <span className={`${styles['atag']} ${styles['atagP']}`}>Personalizado</span>
          <div className={styles['aend']}>
            <div className={styles['aendN']}>1.284</div>
            <div className={`${styles['aendS']} ${styles['aendSok']}`}>✓ atualizado</div>
          </div>
        </div>
        <div className={styles['aud']}>
          <div className={`${styles['aic']} ${styles['aicL']}`}>
            <TbUsersGroup size={20} />
          </div>
          <div className={styles['ainfo']}>
            <b>Lookalike dos reembolsados</b>
            <span>excluir semelhantes</span>
          </div>
          <span className={`${styles['atag']} ${styles['atagK']}`}>Lookalike</span>
          <div className={styles['aend']}>
            <div className={styles['aendN']}>2,1M</div>
            <div className={`${styles['aendS']} ${styles['aendSok']}`}>✓ atualizado</div>
          </div>
        </div>
        <div className={styles['aud']}>
          <div className={`${styles['aic']} ${styles['aicC']}`}>
            <TbShoppingCartX size={20} />
          </div>
          <div className={styles['ainfo']}>
            <b>Carrinho abandonado</b>
            <span>quase comprou</span>
          </div>
          <span className={`${styles['atag']} ${styles['atagP']}`}>Personalizado</span>
          <div className={styles['aend']}>
            <div className={styles['aendN']}>3.910</div>
            <div className={`${styles['aendS']} ${styles['aendSup']}`}>
              <span className={styles['sp']} />
              atualizando
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function RegrasCard() {
  return (
    <>
      <div className={styles['phead']}>
        <div className={styles['rbolt']}>
          <TbBolt size={20} />
        </div>
        <div className={styles['ti']}>
          <b>Regras automáticas</b>
          <span>vigiando suas campanhas</span>
        </div>
        <div className={styles['sy']}>
          <i />
          no ar
        </div>
      </div>
      <div className={styles['rules']}>
        <div className={styles['rule']}>
          <div className={`${styles['ric']} ${styles['ricPa']}`}>
            <TbPlayerPause size={19} />
          </div>
          <div className={styles['rinfo']}>
            <div className={styles['rcond']}>
              <span className={`${styles['kw']} ${styles['kwIf']}`}>SE</span> CPA passar de R$ 40
            </div>
            <div className={styles['ract']}>
              <span className={`${styles['kw']} ${styles['kwThen']}`}>ENTÃO</span> pausar o conjunto
            </div>
          </div>
          <div className={styles['rsw']} />
        </div>
        <div className={styles['rule']}>
          <div className={`${styles['ric']} ${styles['ricUp']}`}>
            <TbTrendingUp size={19} />
          </div>
          <div className={styles['rinfo']}>
            <div className={styles['rcond']}>
              <span className={`${styles['kw']} ${styles['kwIf']}`}>SE</span> ROAS acima de 5x
            </div>
            <div className={styles['ract']}>
              <span className={`${styles['kw']} ${styles['kwThen']}`}>ENTÃO</span> subir orçamento
              +20%
            </div>
          </div>
          <div className={styles['rsw']} />
        </div>
        <div className={styles['rule']}>
          <div className={`${styles['ric']} ${styles['ricDn']}`}>
            <TbTrendingDown size={19} />
          </div>
          <div className={styles['rinfo']}>
            <div className={styles['rcond']}>
              <span className={`${styles['kw']} ${styles['kwIf']}`}>SE</span> ROAS cair de 1,5x
            </div>
            <div className={styles['ract']}>
              <span className={`${styles['kw']} ${styles['kwThen']}`}>ENTÃO</span> reduzir orçamento
              20%
            </div>
          </div>
          <div className={styles['rsw']} />
        </div>
      </div>
      <div className={styles['rlog']}>
        <span className={styles['rlogB']}>
          <TbBolt size={13} />
          há 2h
        </span>{' '}
        pausou o conjunto &quot;Frio 02&quot; sozinha · CPA chegou a R$ 43
      </div>
    </>
  );
}

const CARDS = [
  <ReportCard key="0" />,
  <McpCard key="1" />,
  <PublicosCard key="2" />,
  <RegrasCard key="3" />,
];

export function Funcionalidades() {
  const [cur, setCur] = useState(0);
  const curRef = useRef(0);
  const t0Ref = useRef(0);
  const advancingRef = useRef(false);
  const reduceRef = useRef(false);

  const wrapRef = useRef<HTMLDivElement>(null);
  const cardRefs = useRef<(HTMLDivElement | null)[]>([]);
  const barRefs = useRef<(HTMLSpanElement | null)[]>([]);

  // reset do tempo/barras a cada troca de slide
  useEffect(() => {
    curRef.current = cur;
    t0Ref.current = typeof performance !== 'undefined' ? performance.now() : 0;
    advancingRef.current = false;
    barRefs.current.forEach((b, i) => {
      if (b && i !== cur) b.style.width = '0%';
    });
    // limpa tilt inline dos cards inativos
    cardRefs.current.forEach((c, i) => {
      if (c && i !== cur) c.style.transform = '';
    });
  }, [cur]);

  // auto-advance + animação da barra
  useEffect(() => {
    reduceRef.current =
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceRef.current) return;

    let raf = 0;
    t0Ref.current = performance.now();
    const loop = (now: number) => {
      const p = Math.min(1, (now - t0Ref.current) / DUR);
      const b = barRefs.current[curRef.current];
      if (b) b.style.width = `${p * 100}%`;
      if (p >= 1 && !advancingRef.current) {
        advancingRef.current = true;
        setCur((c) => (c + 1) % N);
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, []);

  // tilt seguindo o cursor (só desktop)
  useEffect(() => {
    const wrap = wrapRef.current;
    if (!wrap) return;
    if (
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    )
      return;

    const onMove = (e: MouseEvent) => {
      if (window.innerWidth < 880) return;
      const c = cardRefs.current[curRef.current];
      if (!c) return;
      const r = wrap.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width - 0.5;
      const py = (e.clientY - r.top) / r.height - 0.5;
      c.style.transform = `rotateX(${(BX - py * 8).toFixed(2)}deg) rotateY(${(BY + px * 12).toFixed(2)}deg)`;
      const sp = c.querySelector<HTMLElement>(`.${styles['spot']}`);
      if (sp) {
        sp.style.setProperty('--mx', `${px * 100 + 50}%`);
        sp.style.setProperty('--my', `${py * 100 + 50}%`);
      }
    };
    const onLeave = () => {
      const c = cardRefs.current[curRef.current];
      if (c) c.style.transform = '';
    };
    wrap.addEventListener('mousemove', onMove);
    wrap.addEventListener('mouseleave', onLeave);
    return () => {
      wrap.removeEventListener('mousemove', onMove);
      wrap.removeEventListener('mouseleave', onLeave);
    };
  }, []);

  // mede a altura do card mais alto pro palco não sobrepor o texto (mobile incluso)
  useEffect(() => {
    const wrap = wrapRef.current;
    if (!wrap) return;
    const measure = () => {
      let h = 0;
      for (const c of cardRefs.current) if (c) h = Math.max(h, c.offsetHeight);
      if (h > 0) wrap.style.height = `${h + 52}px`;
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(wrap);
    window.addEventListener('resize', measure);
    if (typeof document !== 'undefined' && 'fonts' in document) {
      void document.fonts.ready.then(measure);
    }
    const t = setTimeout(measure, 400);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', measure);
      clearTimeout(t);
    };
  }, []);

  const go = (i: number) => setCur(i);

  const s = SLIDES[cur]!;

  return (
    <section className={styles['section']}>
      <div className={styles['wrap']}>
        <p className={styles['eyebrow']}>Funcionalidades</p>
        <h2 className={styles['h2']}>
          Muito mais que um <span className={styles['g']}>simples tracking</span>
        </h2>
        <p className={styles['sub']}>
          A Trakd emite relatórios diários, cria públicos customizados de forma automática direto no
          Gerenciador de Anúncios, tem MCP para Claude Code e muito mais.
        </p>

        <div className={styles['stage']}>
          <div className={styles['cardwrap']} ref={wrapRef}>
            {CARDS.map((card, i) => (
              <div key={i} className={`${styles['slide']} ${i === cur ? styles['slideOn'] : ''}`}>
                <div className={styles['cardshadow']}>
                  <div
                    className={styles['card']}
                    ref={(el) => {
                      cardRefs.current[i] = el;
                    }}
                  >
                    <div className={styles['spot']} />
                    {card}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className={styles['txt']}>
            <h3 className={styles['txtH3']}>
              {s.pre}
              <span className={styles['g']}>{s.g}</span>
              {s.suf}
            </h3>
            <p className={styles['txtP']}>{s.body}</p>
            <div className={styles['nav']}>
              {SLIDES.map((_, i) => (
                <button
                  key={i}
                  type="button"
                  aria-label={`Ir para o card ${i + 1}`}
                  className={`${styles['dot']} ${i === cur ? styles['dotOn'] : ''}`}
                  onClick={() => go(i)}
                >
                  <span
                    className={styles['bar']}
                    ref={(el) => {
                      barRefs.current[i] = el;
                    }}
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Funcionalidades;
